"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactCookie = _interopRequireDefault(require("react-cookie"));
var _classnames = _interopRequireDefault(require("classnames"));
var _parkingEngine = _interopRequireDefault(require("./forms/parking-engine"));
var _hotelsEngine = _interopRequireDefault(require("./forms/hotels-engine"));
var _hotelParkingEngine = _interopRequireDefault(require("./forms/hotel-parking-engine"));
var _DiscountBanner = _interopRequireDefault(require("./components/DiscountBanner"));
var _modal = _interopRequireDefault(require("./components/modal"));
var _salesLabel = _interopRequireDefault(require("./components/salesLabel"));
var _helpers = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/helpers"));
var _ppc = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/ppc"));
var _tracker = _interopRequireDefault(require("static-site-generator-shared/plugins/lib/tracker"));
var _propTypes = require("prop-types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
class MultiEngine extends _react.default.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      selectedProduct: props.selected || this.getSelectedProduct(props)
    };
    this.scrollTo = this.scrollTo.bind(this);
    this.makeSelectOption = this.makeSelectOption.bind(this);
    this.makeOption = this.makeOption.bind(this);
    this.clickLink = this.clickLink.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.showFlight !== this.props.showFlight) return true;
    if (nextProps.hotelParkingFlight !== this.props.hotelParkingFlight) return true;
    if (nextProps.loungeFlight !== this.props.loungeFlight) return true;
    if (nextProps.flightSecondChanceModal !== this.props.flightSecondChanceModal) return true;
    if (nextState.selectedProduct !== this.state.selectedProduct) return true;
    if (nextProps.hiddenLocation !== this.props.hiddenLocation) return true;
    if (nextProps.productList !== this.props.productList) return true;
    if (nextProps.promotionCode !== this.props.promotionCode) return true;
    if (JSON.stringify(nextProps.agentData) !== JSON.stringify(this.props.agentData)) {
      this.updateSelectedProduct(nextProps.agentData);
      return true;
    }
    return false;
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    const selectedProduct = this.updateSelectedProduct(this.props.agentData);
    _tracker.default.track('select_product', selectedProduct);
    const productOptions = this.getProductOptions();
    if (productOptions[selectedProduct] && productOptions[selectedProduct].hasOwnProperty('trackingValue')) {
      _tracker.default.track('select_product', productOptions[selectedProduct].trackingValue, 'public_capture');
    } else {
      console.error('Product options for the selected product: ', selectedProduct, ' does not have a trackingValue property.');
    }
  }
  updateSelectedProduct(agentData) {
    const {
      productCallBack
    } = this.props;
    const selectedProduct = this.getSelectedProduct(this.props);
    this.setState({
      selectedProduct
    });
    productCallBack(selectedProduct);
    return selectedProduct;
  }
  getLocationFromParam() {
    const queryString = _ppc.default.getQueryData();
    return queryString.location || queryString.Location || '';
  }
  getFromParam(param) {
    const queryString = _ppc.default.getQueryData();
    return queryString[param] || queryString[param] || false;
  }
  getFormSettings() {
    if (this.props.formSettings) return this.props.formSettings;
    return require('./config/formSettings');
  }
  getLocations() {
    const dropdowns = this.getDropdowns();
    return dropdowns ? dropdowns.locations : {};
  }
  getDropdowns() {
    if (this.props.dropdowns) return this.props.dropdowns;
    return require('./config/dropdowns');
  }
  getTranslations() {
    if (this.props.translationConfig) return this.props.translationConfig;
    return require('./config/translationConfig');
  }
  getProductOptions() {
    if (this.props.productOptions) return this.props.productOptions;
    return require('./config/productOptions');
  }
  setEngineCookie(product) {
    const {
      cookieKey,
      useCookies
    } = this.props;
    if (!useCookies) return;
    _reactCookie.default.remove(cookieKey, '/');
    const expiry = new Date();
    expiry.setTime(expiry.getTime() + 90 * 24 * 60 * 60 * 1000);
    _reactCookie.default.save(cookieKey, product, {
      expires: expiry,
      path: '/'
    });
  }
  getEngineCookie() {
    const {
      cookieKey,
      setVar,
      useCookies
    } = this.props;
    if (!useCookies) return;
    const selectedProduct = _reactCookie.default.load(cookieKey);
    if (!selectedProduct) return false;
    if (!this.showEngineProduct(null, selectedProduct)) return false;
    if (setVar[selectedProduct + '-engine-link']) return false;
    return selectedProduct;
  }
  getDefaultProduct(productList, selected = 'cp') {
    if (!productList.length) productList = [selected];
    if (productList.indexOf(selected) !== -1) return selected;
    return productList[0];
  }
  getSelectedProduct(props = {}) {
    const {
      selected,
      agentData = {},
      productList = []
    } = props;
    const {
      OptionFlags
    } = agentData;
    let selectedProduct = this.getDefaultProduct(productList, selected);
    if (this._isMounted && this.getEngineCookie()) selectedProduct = this.getEngineCookie();
    const queryString = _ppc.default.getQueryData();
    if (queryString.chosen) {
      const chosen = queryString.chosen.toLowerCase();
      if (productList.length && productList.indexOf(chosen) >= 0) {
        selectedProduct = chosen;
      }
    }
    if (!OptionFlags) {
      try {
        window.performance.mark('Default selected engine option');
      } catch (e) {
        // console.log( e );
      }
      return selectedProduct;
    }
    if (OptionFlags.CarParkBookings === 'N' && OptionFlags.HotelBookings !== 'N' && OptionFlags.HotelParking === 'N') {
      selectedProduct = 'ho';
    } else if (OptionFlags.CarParkBookings === 'N' && OptionFlags.HotelParking !== 'N') {
      selectedProduct = 'hcp';
    } else if (OptionFlags.HotelBookings === 'N' && OptionFlags.CarParkBookings !== 'N') {
      selectedProduct = 'cp';
    }
    try {
      window.performance.mark('Changed selected engine option');
    } catch (e) {
      // console.log( e );
    }
    return selectedProduct;
  }
  navigate(link) {
    window.location = this.appendRequestParams(link);
  }
  paramStringToObj(paramString) {
    const queryString = {};
    paramString.split('&').filter(link => {
      const [name, value] = link.split('=');
      if (!value) return false;
      queryString[name] = value;
    });
    return queryString;
  }
  appendRequestParams(link) {
    if (typeof window === 'undefined') return link;
    // Make a check to ensure were not overiding parameters with ones in the URL
    if (link.indexOf('?') !== -1 && window.location.search !== '') {
      let queryString = this.paramStringToObj(link.split('?')[1]);
      queryString = Object.assign(queryString, this.paramStringToObj(window.location.search.slice(1)));
      return link.split('?')[0] + '?' + Object.keys(queryString).map(key => key + '=' + queryString[key]).join('&');
    }
    const searchParams = link.indexOf('?') !== -1 ? window.location.search.replace('?', '&') : window.location.search;
    return link + searchParams;
  }
  scrollTo(e) {
    // this sits on the back of the tabNavigation.js as per request 24/05
    const href = e.target.getAttribute('data-href') || e.target.closest('a').getAttribute('data-href');
    if (!href) return;
    const ele = _helpers.default.$(`.sideNavContainer [href="${href}"]`);
    if (ele) ele.click();
  }
  clickLink(e) {
    const {
      productCallBack
    } = this.props;
    let el = e.target;
    e.preventDefault();
    if (el && el.tagName === 'SELECT') {
      if (!this.refs['_option_' + el.value]) {
        let optionEl = null;
        [].concat.apply([], el.childNodes).map(option => {
          if (option.value === el.value) optionEl = option;
          return false;
        });
        el = optionEl;
      } else {
        el = this.refs['_option_' + el.value];
      }
      if (el.getAttribute('data-toggle') === 'modal' && el.getAttribute('data-target')) {
        _helpers.default.$('a[data-target="' + el.getAttribute('data-target') + '"]').click();
        return;
      }
    } else {
      let iterator = 0;
      while (el && el.tagName !== 'A' && iterator++ <= 4) {
        el = el.parentElement;
        const anchor = _helpers.default.$('a', el);
        if (anchor) el = anchor.target;
      }
      if (!el || el && el.tagName !== 'A') return;
    }
    let link = el.getAttribute('data-link');
    const modal = el.getAttribute('data-toggle') === 'modal';
    const mobileLink = el.getAttribute('data-mobile-link');
    const selectedProduct = el.getAttribute('data-product');
    const productText = el.getAttribute('data-product-text');
    // on mobile layout we hide the engine so lets link to the pages instead
    const isMobile = _helpers.default.isVisible('.navbar-header .navbar-toggle');
    if (!link && !modal || !isMobile && productText) {
      this.setEngineCookie(selectedProduct);
      this.setState({
        selectedProduct
      });
      if (productCallBack) productCallBack(selectedProduct);
      if (!isMobile && productText) return;
    }
    if (link || isMobile && mobileLink) {
      this.navigate(link || mobileLink);
    }
  }
  getLocationName() {
    const {
      hiddenLocation = false,
      locations = {}
    } = this.props;
    if (!hiddenLocation) return false;
    if (locations.hasOwnProperty('ports') && locations.ports[hiddenLocation]) return locations.ports[hiddenLocation];
    if (locations.hasOwnProperty('altLocationNames') && locations.altLocationNames[hiddenLocation]) return locations.altLocationNames[hiddenLocation];
    if (locations.hasOwnProperty('carParking') && locations.carParking[hiddenLocation]) return locations.carParking[hiddenLocation];
    if (locations.hasOwnProperty('hotels') && locations.hotels[hiddenLocation]) return locations.hotels[hiddenLocation];
    if (locations.hasOwnProperty('lounges')) {
      const loungeLocation = locations.lounges;
      if (loungeLocation.hasOwnProperty('OptGroupAirport') && loungeLocation.OptGroupAirport[hiddenLocation]) return loungeLocation.OptGroupAirport[hiddenLocation];
      if (loungeLocation.hasOwnProperty('OptGroupEurope') && loungeLocation.OptGroupEurope[hiddenLocation]) return loungeLocation.OptGroupEurope[hiddenLocation];
      if (loungeLocation.hasOwnProperty('OptGroupWorldwide') && loungeLocation.OptGroupWorldwide[hiddenLocation]) return loungeLocation.OptGroupWorldwide[hiddenLocation];
    }
    return false;
  }
  optionVisibilityClasses(className, productClass, groupName) {
    const {
      showOtherProductsOnMobile
    } = this.props;
    switch (className) {
      case 'hidden-xs':
        if (((productClass === 'cp' || productClass === 'ho' || productClass === 'hcp') && groupName !== 'selectProductSplit' && groupName !== 'landingPage' && !showOtherProductsOnMobile || productClass !== 'cp' && productClass !== 'ho' && productClass !== 'hcp' && productClass !== 'otherProducts' && groupName === 'tabbedProducts') && productClass !== 'lo' && showOtherProductsOnMobile) return 'hidden-xs';
        return null;
      case 'visible-xs':
        if (productClass === 'otherProducts') return 'hidden';
        return null;
      case 'hidden':
        if ((productClass === 'cp' || productClass === 'ho' || productClass === 'hcp' || productClass === 'otherProducts') && groupName === 'otherProducts') return 'hidden';
        return null;
      default:
        return null;
    }
  }
  getTabPrices(product) {
    const {
      hiddenLocation,
      tabPrices
    } = this.props;
    if (!product || !tabPrices) return false;
    if (!hiddenLocation && tabPrices['all']) return tabPrices['all'][product];
    if (!hiddenLocation || !tabPrices[hiddenLocation] || !tabPrices[hiddenLocation][product] || tabPrices[hiddenLocation][product] === 'false') return false;
    return tabPrices[hiddenLocation][product];
  }
  makeSelectOption({
    product,
    text,
    link
  }, key) {
    const {
      setVar
    } = this.props;
    if (setVar[product + '-engine-link']) link = setVar[product + '-engine-link'];
    return /*#__PURE__*/_react.default.createElement("option", {
      key: key,
      value: product,
      "data-product": product,
      "data-target": '#' + product + 'EngineModal',
      "data-link": link,
      "data-track-name": "select_product",
      "data-track-value": product,
      dangerouslySetInnerHTML: {
        __html: text
      }
    });
  }
  makeOption({
    productClass,
    product,
    salesLabel = false,
    group,
    text,
    homepageText,
    link,
    salesLink = false,
    mobileLink,
    modalHeading,
    modalLead,
    modalContent,
    svg,
    productText
  }, key, groupName) {
    const {
      selectedProduct
    } = this.state;
    let {
      agentData,
      selectedClass,
      setVar,
      hiddenLocation,
      wideTabs,
      isHomepage,
      showDealsTab
    } = this.props;
    const productOptions = this.getProductOptions();
    if (productClass === 'otherProducts') return null;
    const airportName = this.getLocationName();
    if (!showDealsTab && groupName === 'selectProduct' && airportName && hiddenLocation && (productClass === 'cp' || productClass === 'ho' || productClass === 'hcp' || productClass === 'lo')) text = airportName + ' ' + text;
    const convertToDealsTab = showDealsTab && product === 'lo';
    if (setVar[product + '-engine-link']) link = setVar[product + '-engine-link'];
    const checked = selectedProduct === product;
    const classUsed = (0, _classnames.default)(productClass, airportName ? 'airportName' : null, checked ? selectedClass : null, this.optionVisibilityClasses('hidden-xs', productClass, groupName), this.optionVisibilityClasses('visible-xs', productClass, groupName), this.optionVisibilityClasses('hidden', productClass, groupName));
    const tabPrice = this.getTabPrices(product);
    const smallClass = (0, _classnames.default)({
      'small': true,
      'hidden-xs': modalHeading || modalLead || modalContent
    }, group && 'text-' + group);
    const tabClass = (0, _classnames.default)({
      'wideTabPrice': wideTabs,
      showDealsTab
    });
    let smallContent = text;
    if (!airportName && typeof homepageText !== 'undefined') {
      smallContent = homepageText;
    }
    if (showDealsTab && !convertToDealsTab) {
      smallContent += '<span>From <span class="hidden-xs">only</span> <span>&pound;' + tabPrice + '</span></span>';
    } else if (convertToDealsTab) {
      smallContent = 'Airport Hotel <span class="dealsTextLineBreak">&amp; Parking</span> <span class="dealsText">Deals and offers <span class="hidden-xs hidden-sm">today</span> ></span>';
      svg = productOptions.ho.svg;
    } else if (tabPrice && !isHomepage) {
      smallContent += '<span>From &pound;' + tabPrice + '*</span>';
    }
    const doesHaveProductText = productText ? true : '';
    const prodLink = salesLink || link;
    return /*#__PURE__*/_react.default.createElement("li", {
      key: key,
      className: classUsed
    }, (modalHeading || modalLead || modalContent) && /*#__PURE__*/_react.default.createElement("a", {
      "data-product": product,
      "data-link": link,
      onClick: this.clickLink,
      "data-mobile-link": mobileLink,
      htmlFor: 'hxEmbedsp_' + product,
      "data-toggle": "modal",
      "data-target": '#' + product + 'EngineModal',
      "data-track-name": "select_product",
      "data-track-value": product
    }, svg && /*#__PURE__*/_react.default.createElement("span", {
      className: smallClass,
      dangerouslySetInnerHTML: {
        __html: svg
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "small",
      dangerouslySetInnerHTML: {
        __html: text
      }
    })), !convertToDealsTab && !(modalHeading || modalLead || modalContent) && /*#__PURE__*/_react.default.createElement("a", {
      "data-product": product,
      className: tabClass,
      "data-link": prodLink,
      onClick: this.clickLink,
      "data-mobile-link": mobileLink,
      htmlFor: 'hxEmbedsp_' + product,
      "data-product-text": doesHaveProductText,
      "data-track-name": "select_product",
      "data-track-value": product
    }, groupName === 'landingPage' && /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      name: "formFakeInputs",
      checked: checked,
      onChange: this.clickLink
    }), svg && /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: svg
      }
    }), !wideTabs && /*#__PURE__*/_react.default.createElement("p", {
      className: smallClass,
      onTouchStart: this.clickLink,
      dangerouslySetInnerHTML: {
        __html: smallContent
      }
    }), wideTabs && /*#__PURE__*/_react.default.createElement("p", {
      className: smallClass,
      onTouchStart: this.clickLink,
      dangerouslySetInnerHTML: {
        __html: smallContent
      }
    })), convertToDealsTab && /*#__PURE__*/_react.default.createElement("a", {
      "data-product": product,
      "data-href": "#tabDeals",
      onClick: this.scrollTo,
      className: tabClass,
      "data-link": prodLink,
      "data-mobile-link": mobileLink,
      htmlFor: 'hxEmbedsp_' + product,
      "data-product-text": doesHaveProductText,
      "data-track-name": "select_product",
      "data-track-value": "hotelDealsTab"
    }, svg && /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: svg
      }
    }), /*#__PURE__*/_react.default.createElement("small", {
      className: smallClass,
      onTouchStart: this.scrollTo,
      dangerouslySetInnerHTML: {
        __html: smallContent
      }
    }), /*#__PURE__*/_react.default.createElement(_salesLabel.default, {
      showOveride: true,
      labelText: "Deals",
      onTouchStart: this.scrollTo
    })), (modalHeading || modalLead || modalContent) && /*#__PURE__*/_react.default.createElement(_modal.default, {
      id: product + 'EngineModal',
      heading: modalHeading,
      lead: modalLead,
      content: modalContent.replace('##agent##', agentData.agent)
    }));
  }
  cantSellProduct(item, OptionFlags, selectedProduct, agent, groupCode) {
    const {
      agentData: {
        agentsByUrl = {}
      }
    } = this.props;
    if (item.agentExcludeByUrl && item.agentExcludeByUrl.indexOf(Object.keys(agentsByUrl)[0]) > -1 && agentsByUrl[Object.keys(agentsByUrl)[0]]) return true;
    if (selectedProduct !== item.product && OptionFlags && item.canSellFlag && OptionFlags[item.canSellFlag] === 'N') return true;
    return item.agentExclude && item.agentExclude.indexOf(agent) > -1 || item.agentGroupExclude && item.agentGroupExclude.indexOf(groupCode) > -1;
  }
  showEngineProduct(option, productType) {
    const productOptions = this.getProductOptions();
    // checks if the engine should be hidden or not (defaults to showing it)
    if (!productOptions[productType] || productOptions[productType].isHidden) return false;
    const {
      productList
    } = this.props;
    if (productList.length && productList.indexOf(productType) < 0) return false;
    const {
      agentData: {
        OptionFlags
      }
    } = this.props;
    if (!OptionFlags || !option) return true;
    if (OptionFlags[option] === 'N') return false;
    return true;
  }
  getImageFromParamIfExists(param) {
    const paramImage = _helpers.default.getParameterByName(`${param}Image`);
    if (paramImage) return {
      backgroundImage: `url('${paramImage}')`
    };else return {};
  }
  getEngineOptions(productList, groupName) {
    const {
      productDropdown,
      agentData
    } = this.props;
    const {
      selectedProduct
    } = this.state;
    const {
      OptionFlags,
      agent,
      groupCode
    } = agentData;
    const productOptions = this.getProductOptions();
    const optionType = productDropdown ? this.makeSelectOption : this.makeOption;
    if (!productList.length) {
      return Object.keys(productOptions).reduce((result, option) => {
        const product = productOptions[option];
        if (this.cantSellProduct(product, OptionFlags, selectedProduct, agent, groupCode)) return result;
        result.push(optionType(product, option, groupName));
        return result;
      }, []);
    }
    return productList.reduce((products, product) => {
      const result = Object.keys(productOptions).filter(option => {
        const engineOption = productOptions[option];
        if (engineOption.product !== product) return false;
        if (this.cantSellProduct(engineOption, OptionFlags, selectedProduct, agent, groupCode)) return false;
        return true;
      });
      if (!result.length) return products;
      products.push(optionType(productOptions[result[0]], products.length, groupName));
      return products;
    }, []);
  }
  getProductTexts(productList) {
    const {
      agentData
    } = this.props;
    const {
      selectedProduct
    } = this.state;
    const {
      OptionFlags,
      agent,
      groupCode
    } = agentData;
    const productOptions = this.getProductOptions();
    const {
      searchButtonText
    } = this.getTranslations(); // get either default or prop translation config
    if (!productList.length) productList = Object.keys(productOptions);
    return productList.reduce((products, product) => {
      const result = Object.keys(productOptions).filter(option => {
        const engineOption = productOptions[option];
        if (engineOption.product !== product) return false;
        if (!engineOption.productText) return false;
        if (this.cantSellProduct(engineOption, OptionFlags, selectedProduct, agent, groupCode)) return false;
        return true;
      });
      if (!result.length) return products;
      const engineItem = productOptions[result[0]];
      const activeClass = (0, _classnames.default)({
        'hidden': selectedProduct !== engineItem.product
      });
      const prodText = engineItem.salesProductText ? engineItem.salesProductText : engineItem.productText;
      const prodLink = engineItem.salesLink ? engineItem.salesLink : engineItem.link;
      const textNode = /*#__PURE__*/_react.default.createElement("div", {
        key: products.length,
        className: activeClass
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "block-sm bg-default"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "row alternativeProductForm"
      }, /*#__PURE__*/_react.default.createElement("p", {
        dangerouslySetInnerHTML: {
          __html: prodText
        }
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "form-group submit"
      }, /*#__PURE__*/_react.default.createElement("a", {
        className: "mainSubmit btn btn-primary btn-block hxtrack",
        href: this.appendRequestParams(prodLink)
      }, searchButtonText))))));
      products.push(textNode);
      return products;
    }, []);
  }
  getGroupName() {
    const {
      isHomepage,
      groupName,
      showOtherProductsOnMobile
    } = this.props;
    if (groupName) return groupName;
    if (showOtherProductsOnMobile) return 'tabbedProducts';
    if (isHomepage) return 'selectProduct';
    return 'landingPage';
  }
  handleSubmit(e) {
    const {
      submitHandler
    } = this.props;
    if (!submitHandler || typeof submitHandler !== 'function') return true;
    const formData = {};
    const elements = e.target.querySelectorAll('input, select, textarea');
    for (let i = 0; i < elements.length; ++i) {
      const element = elements[i];
      const name = element.name;
      const value = element.value;
      if (name) formData[name] = value;
    }
    submitHandler(formData, e);
  }
  render() {
    const {
      productList,
      splitProducts,
      isHomepage,
      hideOptions,
      productDropdown,
      hotelParkingFlight,
      port,
      engineImage,
      pageData,
      agentData
    } = this.props;
    const {
      selectedProduct
    } = this.state;
    const translations = this.getTranslations();
    const hotelEngineLabels = translations.hotelLabels;
    const Location = this.props.Location ? this.props.Location : this.getLocationFromParam();
    const groupName = this.getGroupName();
    const engineOptions = this.getEngineOptions(productList, groupName);
    const engineImgFromParam = this.getImageFromParamIfExists(selectedProduct);
    const splitProductsOptions = splitProducts.length ? this.getEngineOptions(splitProducts, 'selectProductSplit') : null;
    const engineClass = (0, _classnames.default)({
      'port': port
    });
    const productClass = (0, _classnames.default)({
      'nav': true,
      'nav-tabs': true,
      'nav-justified': splitProductsOptions,
      'sp': true,
      'specialSale': true
    });
    const props = Object.assign({}, this.props, {
      Location,
      selected: selectedProduct,
      translations,
      formSettings: this.getFormSettings(),
      dropdowns: this.getDropdowns(),
      submitHandler: this.handleSubmit
    });
    const productTexts = this.getProductTexts(productList);
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "flatEngine",
      ref: c => {
        this.flatEngine = c;
      },
      className: engineClass
    }, !productDropdown && !hideOptions && (engineOptions.length !== 1 || isHomepage) && /*#__PURE__*/_react.default.createElement("ul", {
      className: productClass
    }, engineOptions), productDropdown && !hideOptions && engineOptions.length !== 1 && /*#__PURE__*/_react.default.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Search"), /*#__PURE__*/_react.default.createElement("select", {
      value: selectedProduct,
      onChange: this.clickLink,
      className: "form-control sp"
    }, engineOptions)), (this.showEngineProduct('HotelBookings', 'ho') && selectedProduct === 'ho' || this.showEngineProduct('PortHotels', 'porthotels') && selectedProduct === 'porthotels') && /*#__PURE__*/_react.default.createElement(_hotelsEngine.default, _extends({}, props, {
      showTerminalsField: false,
      showFlight: false,
      labels: hotelEngineLabels.ho
    })), (this.showEngineProduct('HotelBookings', 'hcp') && selectedProduct === 'hcp' || this.showEngineProduct('PortHotels', 'porthotelswithparking') && selectedProduct === 'porthotelswithparking') && /*#__PURE__*/_react.default.createElement(_hotelParkingEngine.default, _extends({}, props, {
      showTerminalsField: false,
      showFlight: hotelParkingFlight,
      labels: hotelEngineLabels.hcp
    })), (this.showEngineProduct('CarParkBookings', 'cp') && selectedProduct === 'cp' || this.showEngineProduct('PortParking', 'portparking') && selectedProduct === 'portparking') && /*#__PURE__*/_react.default.createElement(_parkingEngine.default, props), productTexts && productTexts, this.props.showDiscountBanner && /*#__PURE__*/_react.default.createElement(_DiscountBanner.default, {
      pageName: pageData.pageName,
      agentData: agentData
    }), engineImage && selectedProduct && /*#__PURE__*/_react.default.createElement("div", {
      className: "homepageImage",
      "data-product": selectedProduct,
      style: engineImgFromParam
    }));
  }
}
MultiEngine.propTypes = {
  agentData: _propTypes.object,
  selectedClass: _propTypes.string,
  hiddenLocation: _propTypes.string,
  cookieKey: _propTypes.string,
  productList: _propTypes.array,
  setVar: _propTypes.object,
  productCallBack: _propTypes.func,
  useCookies: _propTypes.bool,
  productDropdown: _propTypes.bool,
  showFlight: _propTypes.bool,
  showDiscountBanner: _propTypes.bool,
  tabPrices: _propTypes.object,
  splitProducts: _propTypes.array,
  isHomepage: _propTypes.bool,
  engineImage: _propTypes.bool,
  translationConfig: _propTypes.object,
  hideOptions: _propTypes.bool,
  submitHandler: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.bool])
};
MultiEngine.defaultProps = {
  selectedClass: 'active',
  cookieKey: 'chosenEngine',
  setVar: {},
  agentData: {},
  productList: ['cp', 'hcp', 'ho', 'lo', 'meetandgreet', 'ins'],
  splitProducts: ['cp', 'hcp', 'ho', 'lo'],
  domainSettings: {
    language: 'UK',
    scheme: 'https',
    domain: 'www.holidayextras.co.uk',
    agentDomain: 'www.holidayextras.co.uk'
  },
  terminal: '',
  useCookies: true,
  showFlight: false,
  showFlightModal: false,
  showBookingFeesMessage: true,
  showDiscountBanner: true,
  terminalLink: true,
  engineImage: false,
  showTerminalsField: true,
  isHomepage: false,
  showPromoCode: false,
  hideOptions: false,
  submitHandler: false,
  productCallBack: () => true,
  airportCodes: {}
};
var _default = exports.default = MultiEngine;


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-booking-forms-aps/lib/engine-controller.js
// module id = 738
// module chunks = 119